export default {
  clientDashboardMyHome: '/client-dashboard/my-home',
  clientDashboardMySearch: '/client-dashboard/my-search',
  clientDashboardMyTransactions: '/client-dashboard/my-transactions',
  clientDashboard: '/client-dashboard',
};
